import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import relativeTime from "dayjs/plugin/relativeTime";
import "dayjs/locale/en";
import "dayjs/locale/fr-ca";
import "dayjs/locale/es";
import "dayjs/locale/cy";

dayjs.extend(utc);
dayjs.extend(relativeTime);

export const humanize = (
  timestamp: string,
  format = "DD MMM YYYY, H:mm",
  timeZone?: string
): string => {
  if (!timestamp) return null;

  if (timeZone === "local") return dayjs(timestamp).format(format);

  return dayjs(timestamp).utc().format(format);
};

export const dateFromNow = (
  timestamp: string | Date,
  text?: string
): string => {
  if (!timestamp) return null;

  if (text) return dayjs(timestamp).fromNow(true) + ` ${text}`;

  return dayjs(timestamp).fromNow(true);
};

export const dateWithSiteLocale = (
  timestamp: string | Date,
  language?: string
): string => {
  if (!timestamp) return null;

  if (language) return dayjs().locale(language).to(dayjs(timestamp));

  return dayjs().locale("en").to(dayjs(timestamp));
};

export const translateLongDate = (
  timestamp: string | Date,
  format = "DD MMM YYYY",
  language = "en"
): string => {
  if (!timestamp) return null;

  return dayjs(timestamp).utc().locale(language).format(format);
};
